var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16917_4479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 18.3334C14.6037 18.3334 18.3346 14.6025 18.3346 10.0001C18.3346 5.39771 14.6037 1.66675 10.0013 1.66675C5.39893 1.66675 1.66797 5.39771 1.66797 10.0001C1.66797 14.6025 5.39893 18.3334 10.0013 18.3334Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4759 7.07578C11.3876 7.16594 11.3381 7.28716 11.3381 7.41341C11.3381 7.53966 11.3876 7.66088 11.4759 7.75104L12.2477 8.52277C12.3378 8.61114 12.459 8.66064 12.5853 8.66064C12.7115 8.66064 12.8328 8.61114 12.9229 8.52277L14.7413 6.70438C14.9838 7.24034 15.0573 7.83749 14.9518 8.41624C14.8464 8.995 14.567 9.52787 14.1511 9.94385C13.7351 10.3598 13.2022 10.6392 12.6235 10.7446C12.0447 10.8501 11.4476 10.7766 10.9116 10.5341L7.5787 13.867C7.38682 14.0589 7.12657 14.1667 6.85521 14.1667C6.58384 14.1667 6.3236 14.0589 6.13171 13.867C5.93983 13.6751 5.83203 13.4149 5.83203 13.1435C5.83203 12.8721 5.93983 12.6119 6.13171 12.42L9.46461 9.08709C9.22208 8.55113 9.14865 7.95399 9.2541 7.37523C9.35955 6.79648 9.63887 6.26361 10.0549 5.84763C10.4708 5.43165 11.0037 5.15233 11.5825 5.04687C12.1612 4.94142 12.7584 5.01486 13.2943 5.25739L11.4808 7.07095L11.4759 7.07578Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16917_4479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage);
export default __webpack_public_path__ + "static/media/manage.2de2650b4e8e7c5639bd69ee41039852.svg";
export { ForwardRef as ReactComponent };